export const menusDTOFields = {
    name: 'name',
    dateFrom: 'dateFrom',
    dateTo: 'dateTo',
    attachments: 'attachments',
} as const;
